import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'
import { Career } from '../types/career.types'

export const useCareerQuery = (careerId: string, options = {}) => {
  return useQuery<Career>({
    queryKey: QUERY_KEYS.careerById(careerId),
    queryFn: () =>
      query({
        query: 'getCareer',
        variables: { id: careerId },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      }),
    enabled: !!careerId
  })
}
